import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';
import CloseIcon from '@nykaa/ui-components/Icons/close';
import OverlaySheetBase, { SHEET_TRANSITION } from 'shared/components/OverlaySheet';
import { MY_SAVED_PAYMENTS } from 'shared/constants/uri';

const OverlaySheet = styled(OverlaySheetBase)`
  background-color: #fff;
  height: 100%;
  width: 30%;
  max-width: 400px;
  left: initial;
  overflow-y: auto;
  overflow-x: hidden;
`;

const IFrame = styled.iframe`
  height: ${({ theme }) => `calc(100% - ${theme.spacing.spacing200})`};
  width: 100%;
  border: 0;
  display: block;
`;

const SavedPaymentsHeader = styled.div`
  position: relative;
  height: ${({ theme }) => theme.spacing.spacing200};
  flex: 0 0 ${({ theme }) => theme.spacing.spacing200};
`;

const CloseButton = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.spacing.spacing80};
  left: ${({ theme }) => theme.spacing.spacing100};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`;

const SavedPaymentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

interface IDwebSavedPaymentsProps {
  onHide: VoidFunction;
}

function DwebSavedPayments({ onHide }: IDwebSavedPaymentsProps) {
  return (
    <OverlaySheet
      navKey="dweb-saved-payments"
      disableNav
      onHide={onHide}
      transitionFrom={SHEET_TRANSITION.RIGHT}
    >
      <SavedPaymentsContainer>
        <SavedPaymentsHeader>
          <CloseButton onClick={onHide} aria-label="Close Saved Payments">
            <CloseIcon />
          </CloseButton>
        </SavedPaymentsHeader>
        <IFrame src={MY_SAVED_PAYMENTS} title="Saved Payments" />
      </SavedPaymentsContainer>
    </OverlaySheet>
  );
}

export default memo(DwebSavedPayments);
